import { dataHooks } from '../../../../../libs/dataHooks';

export const categoriesListItemDataHooks = dataHooks<{
  item;
  link;
}>('categories-list-item');
